import React, { useState, useEffect, useCallback, memo, useContext } from 'react';
// import { StoreContext } from '../Store/StoreProvider';
import {
    Backdrop,
    Button,
    CircularProgress,
    Fab,
    Grid,
    IconButton,
    LinearProgress,
    Menu,
    MenuItem,
    Paper,
    TextField,
    Tooltip,
    withWidth,
} from '@material-ui/core';
import {
    AccountCircle as AccountCircleIcon,
    AddCircleOutline as AddCircleOutlineIcon,
    AlternateEmail as AlternateEmailIcon,
    Delete as DeleteIcon,
    MoreVert as MoreVertIcon,
    PermIdentity as PermIdentityIcon,
    Phone as PhoneIcon,
    PhoneIphone as PhoneIphoneIcon,
    Refresh as RefreshIcon,
    Save as SaveIcon,
    Search as SearchIcon,
} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';
import { useAuth } from "../Auth";
import swal from 'sweetalert';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import {
    Checkbox as CheckboxAntd,
    Modal as ModalAntd,
    Switch as SwitchAntd,
    Table as TableAntd,
    Tooltip as TooltipAntd,
} from 'antd';
import SwapVerticalCircleIcon from '@material-ui/icons/SwapVerticalCircle';
import mapboxgl from 'mapbox-gl';
import ServiciosFibra from './components/ServiciosFibra';
import ServiciosRadio from './components/ServiciosRadio';


mapboxgl.accessToken = 'pk.eyJ1Ijoic2pjYXN0aWxsb2ciLCJhIjoiY2wxMWVkaDJuMnVhbzNqcW9iM3F4OGt4ZSJ9.hrEONHeoraHrkJTV4ervWQ';

const columnsSearch = [
    {
        title: 'Cliente',
        dataIndex: 'Nombres',
        key: 'Nombres',
    },
    {
        title: 'Cedula',
        dataIndex: 'CI',
        key: 'CI',
    },
    {
        title: 'idForMikrotik',
        dataIndex: 'idForMikrotik',
        key: 'idForMikrotik',
    },
    {
        title: 'Zona Cliente',
        dataIndex: 'ZonaService',
        key: 'ZonaService',
    },
];

const moment = require('moment-timezone');

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 5,
        padding: 5,
        overflow: 'hidden',
    },
    rootCI: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: -1,
        height: 41
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    headerButton: {
        overflow: 'hidden',
        background: '#fff',
        display: 'flex',
        justifyContent: 'center',
        padding: 5,
        position: 'sticky',
        top: 0,
        zIndex: 2,
    },
    inputUp: {
        borderBottom: ' 4px solid #0E3B5F',
        borderRight: ' 4px solid #0E3B5F',
        borderTop: ' 1px solid #0E3B5F',
        borderLeft: '1px solid #0E3B5F',
        padding: 10,
        color: '#0E3B5F',
        textTransform: 'uppercase',
        fontWeight: 'bolder',
        cursor: 'pointer',
        borderRadius: '8px',
        width: '100%'
    },
    media: {
        height: 200,
        border: '1px solid red',
        //paddingTop: '56.25%', // 16:9
    },
    containerUpload: {
        maxHeight: 450,
        height: 450
    },
    rootCard: {
        height: 350
    }
}));

function YounetClientAdd({ widthWin }) {
    const classes = useStyles();
    // const [{ isSocket }] = useContext(StoreContext)
    const { authTokens, openDrawer, setRuta } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const [ DatosF, setDatosF] = useState({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '', Zona: '' });
    const [ correos, setCorreos] = useState([]);
    const [ celulares, setCelulares] = useState([]);
    const [ convencionales, setConvencionales] = useState([]);
    const [ servicios, setServicios] = useState([]);
    const [ isFibra, setFibra] = useState(false);
    const [ elementDisable, setElementDisable] = useState(true);
    const [ isNew, setNew] = useState(true);
    const [ isSaving, setSaving] = useState(false);
    const [ openBackDrop, setOpenBackDrop] = useState(false);
    const [ isSavingClient, setSavingClient] = useState(false);
    const [ userName, setUserName] = useState('');
    const [ showAutocomplete, setShowAutocomplete] = useState(true);
    const [ dataZona, setDataZona] = useState([]);
    const [ zonaSelected, setZonaSelected] = useState('');
    const [ zonaSelectedObject, setZonaSelectedObject] = useState({});
    const [ isSelectedZona, setSelectedZona] = useState(false);
    const [ getArrIdForMikrotik, setArrIdForMikrotik] = useState([]);
    const [ getAddClientMikrotik, setAddClientMikrotik] = useState(false); const [getTecnologias, setTecnologias] = useState([]);
    const [ getTecnicos, setTecnicos] = useState([]);
    const [ getReadyInfo, setReadyInfo] = useState(false);
    const [ getPlanes, setPlanes] = useState([]);
    const [ isSelectClient, setSelectClient] = useState(false);
    const [ isAllClients, setAllClients] = useState(false);
    const [ getInfoUsuarios, setInfoUsuarios] = useState([]);
    const [ getEquiposAll, setEquiposAll] = useState([]);
    const [ isIpsCharging, setIpsCharging] = useState(false);
    const [ getSelectedClient, setSelectedClient] = useState('');
    const [ isResetClient, setResetClient] = useState(false);
    const [ allClientes, setAllClientes ] = useState([]);
    const [ backupAllClientes, setBackupAllClientes ] = useState([]);
    const [ getSearch, setSearch ] = useState('');
    const [ getOptionSearch, setOptionSearch ] = useState('Nombres');
    const [ rows, setRows ] = useState([]);
    const [ isOpenSearch, setOpenSearch ] = useState(false);
    const [ openMenuBusqueda, setOpenMenuBusqueda ] = useState(null);
    const [ clientes, setClientes ] = useState([])

    useEffect(() => {
        (async () => {
            setRuta('/Clientes/Add');
            const dataZonas = await fetch(`/api/zonas/byEmpresa/${authTokens.Empresa}`);
            const resultZonas = await dataZonas.json();
            if(authTokens.Type === 'ADMINISTRADOR'){
                setDataZona(resultZonas);
            }else{
                const ZonasArr = authTokens.Zonas.map(valZon => valZon.Zona);
                const arrFilZona = resultZonas.filter(value => ZonasArr.includes(value.Zona.toString()));
                setDataZona(arrFilZona);
            }
            setReadyInfo(true);
            fetch('/api/clientes/Filtradas',
                { 
                    method:'POST', 
                    body: JSON.stringify({Empresa:authTokens.Empresa, lasZonas:authTokens.Zonas, Tipo:authTokens.Type}), 
                    headers:{'Content-Type': 'application/json'}
                }) 
            .then(response=> response.json())
            .then(result =>{
                const arrAll = [];
                for(const y in result){
                    if(result[y].Servicios.length > 0){ 
                        for(const x in result[y].Servicios){
                            const objeto = {...result[y], ...result[y].Servicios[x]};
                            arrAll.push(objeto);
                        }
                    }
                }
                setAllClientes(arrAll.filter(el=> el !== undefined));
                setBackupAllClientes(arrAll.filter(el=> el !== undefined));
            });
            const getAp3 = await fetch('/api/Planes');
            const arr_Ap3 = await getAp3.json();
            const getAp2 = await fetch('/api/Tecnologias');
            const arr_Ap2 = await getAp2.json();
            const dataTecnicos = await fetch(`/api/users/tecnicos/byEmpresa/${authTokens.Empresa}`);
            const jsonTecnicos = await dataTecnicos.json();
            const getAp1 = await fetch('/api/users');
            const arr_Ap1 = await getAp1.json();
            const getAp1_ = await fetch('/api/EquiposAls');
            const arr_Ap1_ = await getAp1_.json();
            setTecnicos(jsonTecnicos);
            setTecnologias(arr_Ap2);
            setPlanes(arr_Ap3);
            setInfoUsuarios(arr_Ap1);
            setEquiposAll(arr_Ap1_);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (isResetClient) {
            setResetClient(false);
            handleSelectName(getSelectedClient);
        }
    }, [isResetClient]); // eslint-disable-line react-hooks/exhaustive-deps 

    const handleAlertSaveCliente = () => {
        setSaving(true);
        setSavingClient(true);
        swal({
            title: "Desea Guardar este Cliente?",
            icon: "info",
            buttons: true,
        })
            .then((value) => {
                if (value) {
                    handleValidacion();
                } else {
                    setTimeout(() => {
                        setSaving(false);
                        setSavingClient(false);
                    }, 500)
                }
            });
    };

    const handleAlertCloseSave = () => {
        setTimeout(() => {
            setSaving(false);
            setSavingClient(false);
        }, 500)
    };

    const handleDatos = (e) => {
        if (e.target.id === 'Nombres') {
            setDatosF({ ...DatosF, [e.target.id]: e.target.value.toUpperCase() })
        } else {
            setDatosF({ ...DatosF, [e.target.id]: e.target.value })
        }

    };

    const handleDatosCI = (e) => {
        setDatosF({ ...DatosF, [e.target.id]: e.target.value.trim() })
    };

    const handleServicio = () => {
        Swal.fire({
            title: 'DESEA AGREGAR UN SERVICIO',
            icon: 'info',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonColor: '#005596',
            width: 600,
            confirmButtonText: 'SI',
            denyButtonText: 'NO'
        }).then((result) => {
            if (result.isConfirmed) {
                setSelectClient(true);
                //const laZona="America/Guayaquil";
                //const laFecha = moment().tz(laZona).format();
                const arr = [...servicios];
                //const x = DatosF.Nombres.split(' ');
                const objeto = {
                    Numero: arr.length + 1,
                    FOptica: isFibra,
                    TipoServicioMk: zonaSelectedObject.simpleQueue ? 'simpleQueue' : zonaSelectedObject.queueTree ? 'queueTree' : zonaSelectedObject.ppoeList ? 'ppoeList' : 'sysintercom',
                    TipoServicio: isFibra ? 'Fibra Optica' : 'Radio Enlace',
                    isNew: true,
                    idUiid: `${DatosF.CI}_${uuidv4()}`,
                    Status: 'Activo',

                };
                arr.push(objeto);
                setServicios(arr);
            }
        })

    };

    const handleSearchCedula = async () => {
        if (DatosF.CI === '' || DatosF.CI.length < 4) {
            enqueueSnackbar('C.I. INCORRECTO', { variant: 'error' });
        } else {
            setOpenBackDrop(true);
            fetch('/api/clientes/cedula', {
                method: 'POST',
                body: JSON.stringify({ CI: DatosF.CI, Zona: zonaSelected }),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => response.json())
                .then(result => {
                    if (result.noServices) {
                        setOpenBackDrop(false);
                        enqueueSnackbar('CLIENTE SIN SERVICIOS', { variant: 'info' });
                        setElementDisable(false);
                        setDatosF(result.data);
                        setCelulares(result.data.Celular);
                        setConvencionales(result.data.Convencional);
                        setCorreos(result.data.Correo);
                        setNew(false);
                    } else
                        if (result.message) {
                            setOpenBackDrop(false);
                            enqueueSnackbar(result.message, { variant: 'info' });
                            setElementDisable(false);
                            setCelulares([{ celular: '593', id: `Celular_${Math.floor(Math.random() * 10000000)}` }]);
                            setCorreos([{ correo: '', id: `Correo_${Math.floor(Math.random() * 10000000)}` }]);
                            setConvencionales([{ convencional: '593', id: `Convencional_${Math.floor(Math.random() * 10000000)}` }]);
                        } else if (result.Info) {
                            setOpenBackDrop(false);
                            Swal.fire({
                                title: 'CLIENTE TIENE SERVICIOS EN OTRAS ZONAS',
                                text: result.Info,
                                icon: 'info',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor: '#005596',
                                width: 750
                            }).then(() => {
                                Swal.fire({
                                    title: 'DESEA CAMBIAR DE ZONA?',
                                    icon: 'info',
                                    confirmButtonText: 'SI',
                                    denyButtonText: 'NO',
                                    showDenyButton: true,
                                    showCancelButton: true,
                                    confirmButtonColor: '#005596',
                                    width: 500
                                }).then(resServ => {
                                    if (resServ.isDenied) {
                                        setDatosF(result.data);
                                        setCelulares(result.data.Celular);
                                        setConvencionales(result.data.Convencional);
                                        setCorreos(result.data.Correo);
                                        setElementDisable(false);
                                        setNew(false);
                                    } else if (resServ.isConfirmed) {
                                        setDatosF({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '' });
                                        setNew(true);
                                        setUserName('');
                                        setShowAutocomplete(true);
                                        setZonaSelected('');
                                        setZonaSelectedObject({});
                                        setSelectedZona(false);
                                        //setDataClientes([]);
                                    }
                                })
                            });
                        } else if (result.status) {
                            Swal.fire({
                                title: result.status,
                                icon: 'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor: '#005596',
                                width: 450,
                                toast: true
                            });
                            setDatosF({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '' });
                            setNew(true);
                            setUserName('');
                            setShowAutocomplete(true);
                            setZonaSelected('');
                            setZonaSelectedObject({});
                            setSelectedZona(false);
                            //setDataClientes([]);
                        } else {
                            setOpenBackDrop(false);
                            setNew(false);
                            enqueueSnackbar('Cliente Existente', { variant: 'info' });
                            setElementDisable(false);
                            setDatosF(result);
                            setCelulares(result.Celular);
                            setConvencionales(result.Convencional);
                            setCorreos(result.Correo);
                            if (result.Servicios.length > 0) {
                                setServicios(result.Servicios);
                                setSelectClient(true);
                            }
                        }
                });

        }
    };

    const handleValidacion = () => {
        if (DatosF.CI === '' || DatosF.Nombres === '' || correos[0].correo === '' || convencionales[0].convencional === '' || celulares[0].celular === '') {
            enqueueSnackbar('Casilleros Incompletos', { variant: 'error' });
            handleAlertCloseSave();
        } else if (correos[0].correo.split('@').length !== 2) {
            enqueueSnackbar('Error Correo', { variant: 'error' });
            handleAlertCloseSave();
        } else if (celulares[0].celular.length < 10) {
            enqueueSnackbar('Error Celular', { variant: 'error' });
            handleAlertCloseSave();
        } else if (convencionales[0].convencional.length < 9) {
            enqueueSnackbar('Error Convencional', { variant: 'error' });
            handleAlertCloseSave();
        } else {
            handleSave();
        }
    };

    const handleSave = () => {
        const laZona = "America/Guayaquil";
        const laFecha = moment().tz(laZona).format();
        if (isNew) {
            fetch('/api/clientes', {
                method: 'POST',
                body: JSON.stringify({
                    CI: DatosF.CI,
                    Nombres: DatosF.Nombres,
                    Registro: laFecha,
                    Modificacion: laFecha,
                    Correo: correos,
                    Celular: celulares,
                    Convencional: convencionales,
                    isNew: isNew,
                    Status: 'Activo',
                    Vendedor: authTokens.Nombres,
                    Sector: authTokens.Sector,
                    Zona: zonaSelected,
                    Empresa: authTokens.Empresa,
                    Zonas: []
                }),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => response.json())
                .then(result => {
                    if (result._id) {
                        enqueueSnackbar('Cliente Agregado', { variant: 'success' });
                        setDatosF({ ...DatosF, Correo: correos, Celular: celulares, Convencional: convencionales, _id: result._id, Zonas: [] });
                        setNew(false);
                        setTimeout(() => {
                            setSaving(false);
                            setSavingClient(false);
                        }, 1000)
                    } else {
                        enqueueSnackbar(`Error ${result.status}`, { variant: 'error' });
                        setTimeout(() => {
                            setSaving(false);
                            setSavingClient(false);
                        }, 1000)
                    }
                });
        } else {
            const objeto = { ...DatosF };
            objeto.Modificacion = laFecha;
            objeto.Correo = correos;
            objeto.Celular = celulares;
            objeto.Convencional = convencionales;
            objeto.isNew = false;
            fetch('/api/clientes', {
                method: 'POST',
                body: JSON.stringify(objeto),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => response.json())
                .then(result => {
                    if (result.message) {
                        enqueueSnackbar(result.message, { variant: 'success' });
                        setNew(false);
                        setTimeout(() => {
                            setSaving(false);
                            setSavingClient(false);
                        }, 1000)
                    } else {
                        enqueueSnackbar(`Error ${result.status}`, { variant: 'error' });
                        setTimeout(() => {
                            setSaving(false);
                            setSavingClient(false);
                        }, 1000)
                    }
                });
        }
    };

    const handleReset = () => {
        setOpenBackDrop(true);
        setElementDisable(true);
        setServicios([]);
        setCorreos([]);
        setConvencionales([]);
        setCelulares([]);
        setFibra(false);
        setSavingClient(false);
        setNew(true);
        setDatosF({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '' });
        setOpenBackDrop(false);
        setUserName('');
        setShowAutocomplete(true);
        setZonaSelected('');
        setZonaSelectedObject({});
        setSelectedZona(false);
        setSelectClient(false);
    };

    const handleResetName = () => {
        setOpenBackDrop(true);
        setElementDisable(true);
        setServicios([]);
        setCorreos([]);
        setConvencionales([]);
        setCelulares([]);
        setSavingClient(false);
        setNew(true);
        setDatosF({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '' });
        setOpenBackDrop(false);
        setUserName('');
        setShowAutocomplete(true);
        setSelectClient(false);
    };

    const handleShowAutocomplete = (checked) => { setShowAutocomplete(checked) };

    const handleSelectName = (value) => {
        new Promise((resolver, rechazar) => {
            setUserName(value);
            const arrFil_ = clientes.filter(value2 => value2.Zonas.includes(zonaSelected));
            const arrFil = arrFil_.filter(value2 => value2.Nombres.toString() === value.toString());
            if (arrFil.length === 1) {
                if (arrFil[0].Servicios.length === 0) {
                    if (arrFil[0].Zona === zonaSelected) {
                        resolver(arrFil[0]);
                    } else {
                        Swal.fire({
                            title: `ESTE CLIENTE ESTA REGISTRADO EN LA ZONA ${arrFil[0].Zona}`,
                            icon: 'info',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor: '#005596',
                            width: 750,
                            toast: true,
                        }).then(() => {
                            Swal.fire({
                                title: `DESEA CAMBIAR DE ZONA A ESTE CLIENTE?`,
                                icon: 'info',
                                showDenyButton: true,
                                showCancelButton: false,
                                confirmButtonColor: '#005596',
                                width: 750,
                                confirmButtonText: 'SI',
                                denyButtonText: 'NO'
                            }).then((resultFire) => {
                                if (resultFire.isDenied) {
                                    setDatosF({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '' });
                                    setNew(true);
                                    setUserName('');
                                    setShowAutocomplete(true);
                                    setZonaSelected('');
                                    setZonaSelectedObject({});
                                    setSelectedZona(false);
                                    setCelulares([]);
                                    setConvencionales([]);
                                    setCorreos([]);
                                    
                                    
                                    
                                    //setDataClientes([]);
                                } else if (resultFire.isConfirmed) {
                                    fetch('/api/clientesNoService', {
                                        method: 'PUT',
                                        body: JSON.stringify({ Nombres: value, Zona: zonaSelected }),
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }
                                    })
                                        .then(response => response.json())
                                        .then(resultPut => {
                                            if (resultPut.message) {
                                                enqueueSnackbar(resultPut.message, { variant: 'success' })
                                                resolver(arrFil[0]);
                                            } else {
                                                enqueueSnackbar(resultPut.status, { variant: 'error' })
                                            }

                                        })

                                }
                            })
                        })
                    }
                } else {
                    resolver(arrFil[0]);
                }
            }
        })
            .then((inf) => {
                setDatosF(inf);
                setOpenBackDrop(false);
                setElementDisable(false);
                setCelulares(inf.Celular);
                setConvencionales(inf.Convencional);
                setCorreos(inf.Correo);
                if (inf.Servicios.length > 0) {
                    const arrFiltrado = inf.Servicios.filter(el => el.ZonaService.toString() === zonaSelected);
                    setServicios(arrFiltrado);
                    setSelectClient(true);
                }
                setNew(false);
                setOpenBackDrop(false);
            })
            .catch((err) => {
                alert(`Error en el Sistema: ${err}`)
                // console.log(err);
            });
    };

    const handleCrearCorreos = useCallback(() => {
        const arrCorreos = [...correos];
        const objeto = { correo: '', id: `Correo_${Math.floor(Math.random() * 10000000)}` };
        arrCorreos.push(objeto);
        setCorreos(arrCorreos);
    }, [correos]);

    const handleBorrarCorreos = useCallback((id) => {
        const arrCorreos = [...correos];
        const filElement = arrCorreos.filter(value => value.id !== id);
        setCorreos(filElement);
    }, [correos]);

    const handleCorreos = useCallback((idElement, valElement) => {
        const arrCorreos = [...correos];
        const arr = arrCorreos.map(value => {
            const objeto = { ...value }
            if (value.id === idElement) {
                return valElement;
            } else {
                return objeto;
            }
        });
        setCorreos(arr);
    }, [correos]);

    const CorreosEl = correos.map((value, index) => (
        <ElementCorreo
            index={index}
            key={`Correo-${index}`}
            data={value}
            total={correos.length}
            disabledEl={elementDisable}
            handleCrearCorreos={handleCrearCorreos}
            handleBorrarCorreos={handleBorrarCorreos}
            handleCorreos={handleCorreos}
        />
    ));

    const handleCrearCelulares = useCallback(() => {
        const arrElemento = [...celulares];
        const objeto = { celular: '593', id: `Celular_${Math.floor(Math.random() * 10000000)}` };
        arrElemento.push(objeto);
        setCelulares(arrElemento);
    }, [celulares]);

    const handleBorrarCelulares = useCallback((id) => {
        const arrElemento = [...celulares];
        const filElement = arrElemento.filter(value => value.id !== id);
        setCelulares(filElement);
    }, [celulares]);

    const handleCelulares = useCallback((idElement, valElement) => {
        const arrElemento = [...celulares];
        const arr = arrElemento.map(value => {
            const objeto = { ...value }
            if (value.id === idElement) {
                return valElement;
            } else {
                return objeto;
            }
        });
        setCelulares(arr);
    }, [celulares]);

    const CelularesEl = celulares.map((value, index) => (
        <ElementCelular
            index={index}
            key={`celular_${index}`}
            data={value}
            total={celulares.length}
            disabledEl={elementDisable}
            handleCrearCelulares={handleCrearCelulares}
            handleBorrarCelulares={handleBorrarCelulares}
            handleCelulares={handleCelulares}
        />
    ));

    const handleCrearConvencionales = useCallback(() => {
        const arrElemento = [...convencionales];
        const objeto = { celular: '593', id: `Convencional_${Math.floor(Math.random() * 10000000)}` };
        arrElemento.push(objeto);
        setConvencionales(arrElemento);
    }, [convencionales]);

    const handleBorrarConvencionales = useCallback((id) => {
        const arrElemento = [...convencionales];
        const filElement = arrElemento.filter(value => value.id !== id);
        setConvencionales(filElement);
    }, [convencionales]);

    const handleConvencionales = useCallback((idElement, valElement) => {
        const arrElemento = [...convencionales];
        const arr = arrElemento.map(value => {
            const objeto = { ...value }
            if (value.id === idElement) {
                return valElement;
            } else {
                return objeto;
            }
        });
        setConvencionales(arr);
    }, [convencionales]);

    const ConvencionalesEl = convencionales.map((value, index) => (
        <ElementConvencional
            index={index}
            key={`Convencional_${index}`}
            data={value}
            total={convencionales.length}
            disabledEl={elementDisable}
            handleCrearConvencionales={handleCrearConvencionales}
            handleBorrarConvencionales={handleBorrarConvencionales}
            handleConvencionales={handleConvencionales}
        />
    ));

    const handleClearZona = () => {
        setOpenBackDrop(true);
        setElementDisable(true);
        setServicios([]);
        setCorreos([]);
        setConvencionales([]);
        setCelulares([]);
        setFibra(false);
        setSavingClient(false);
        setNew(true);
        setDatosF({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '' });
        setOpenBackDrop(false);
        setUserName('');
        setShowAutocomplete(true);
        setZonaSelected('');
        setZonaSelectedObject({});
        setSelectedZona(false);
        setSelectClient(false);
        setSelectedClient('');
    };

    const handleBorrarServicioMongo = useCallback((elDelete) => {
        setServicios((servArr)=> servArr.filter(value => value._id !== elDelete._id));
    }, []);

    const handleBorrarServicio = useCallback(() => {
        setServicios((servArr)=> servArr.pop());
    }, []);

    const handlePostServicio = useCallback((elPost) => {
        setServicios((arrServ)=>( 
            arrServ.map(elServ =>(  
                elServ.idUiid === elPost.idUiid 
                ? elPost 
                : elServ
            ))
        ));
    }, []);

    const handlePutServicio = useCallback((elPut) => {
        setServicios((arrServ)=>(
            arrServ.map(elServ =>(  
                elServ._id === elPut._id
                ? elPut 
                : elServ 
            ))
        ));
    }, []);

    const ServiciosEls = servicios.map((valueServicios, indexServ) => (
        <React.Fragment key={`Servicio_${indexServ}`}>
            {
                valueServicios.TipoServicio === 'Fibra Optica' ?
                    <ServiciosFibra
                        authTokens={authTokens}
                        classes={classes}
                        data={valueServicios}
                        dataCliente={DatosF}
                        enqueueSnackbar={enqueueSnackbar}
                        getArrIdForMikrotik={getArrIdForMikrotik}
                        getAddClientMikrotik={getAddClientMikrotik}
                        getTecnicos={getTecnicos}
                        getTecnologias={getTecnologias}
                        getPlanes={getPlanes}
                        getInfoUsuarios={getInfoUsuarios}
                        getEquiposAll={getEquiposAll}
                        handleBorrarServicio={handleBorrarServicio}
                        handleBorrarServicioMongo={handleBorrarServicioMongo}
                        handlePostServicio={handlePostServicio}
                        handlePutServicio={handlePutServicio}
                        index={indexServ}
                        openDrawer={openDrawer}
                        widthWin={widthWin}
                        zonaSelected={zonaSelectedObject}
                        /> :
                    <ServiciosRadio
                        index={indexServ}
                        zonaSelected={zonaSelectedObject}
                        data={valueServicios}
                        dataCliente={DatosF}
                        authTokens={authTokens}
                        handlePostServicio={handlePostServicio}
                        handlePutServicio={handlePutServicio}
                        handleBorrarServicio={handleBorrarServicio}
                        openDrawer={openDrawer}
                        handleBorrarServicioMongo={handleBorrarServicioMongo}
                        widthWin={widthWin}
                        classes={classes}
                        getArrIdForMikrotik={getArrIdForMikrotik}
                        getAddClientMikrotik={getAddClientMikrotik}
                        getTecnicos={getTecnicos}
                        enqueueSnackbar={enqueueSnackbar}
                        getPlanes={getPlanes}
                        getInfoUsuarios={getInfoUsuarios}
                        getEquiposAll={getEquiposAll}
                    />
            }
        </React.Fragment>
    ));

    const handleAddClientMikrotik = (checked) => { setAddClientMikrotik(checked) };

    const handleClientSelected = (value) => {
        setSelectedClient(value);
        handleResetName();
        setResetClient(true);
    };

    const handleSelectedZona = (valZ) => {
        setIpsCharging(true);
        fetch('/api/clientes/byEmpresa&Zona',
            { 
                method:'POST', 
                body: JSON.stringify({Empresa:authTokens.Empresa, Zona:valZ}), 
                headers:{'Content-Type': 'application/json'}
            }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.Status){
                enqueueSnackbar(result.Status, {variant:'error'})
            }else{
                setZonaSelected(valZ);
                const zoneObject = dataZona.find(value=> value.Zona.toString() === valZ.toString())
                const resultClientes = result.filter(value=>value.Status === 'Activo');
                const arrClientes = [];
                const arrIdfM = [];
                for(const x in resultClientes){
                    const objeto = {...resultClientes[x]};
                    const arrFiltrado = resultClientes[x].Servicios.filter(value=>value.ZonaService === valZ);
                    for (const y in objeto.Servicios) { arrIdfM.push(objeto.Servicios[y].idForMikrotik) };
                    if(arrFiltrado.length > 0){
                        objeto.Servicios = arrFiltrado;
                        arrClientes.push(objeto);
                    }

                    if(objeto.Servicios.length === 0 ){
                        arrClientes.push(objeto);
                    }
                }
                setArrIdForMikrotik(arrIdfM);
                setSelectedZona(true);
                setClientes(arrClientes);
                setZonaSelectedObject(zoneObject);
                zoneObject.isFibraOptica ? setFibra(true) : setFibra(false);
                setAddClientMikrotik(zoneObject.AddClientMikrotik);
                setIpsCharging(false);               
                setElementDisable(true);
                setServicios([]);
                setCorreos([]);
                setConvencionales([]);
                setCelulares([]);
                setSavingClient(false);
                setNew(true);
                setDatosF({ Registro: '', Modificacion: '', Nombres: '', Servicios: [], CI: '' });
                setUserName('');
                setSelectClient(false);
                setSelectedClient('');
            }
        });
    };

    const handleSearch = ({target})=>{
        setSearch(target.value);
        if(target.value === ''){
            setRows(backupAllClientes);
        }else{
            setRows(allClientes.filter(el=>el[getOptionSearch].toString().toLowerCase().includes(target.value.toLowerCase())));
        }
    };

    const handleClickMenuBusqueda = (event) => { setOpenMenuBusqueda(event.currentTarget); };

    const handleCloseMenuBusqueda = () => { setOpenMenuBusqueda(null) };

    const handleOpenSearch = ()=>{ setOpenSearch(true); };

    const handleCloseSearch = ()=>{ setOpenSearch(false); };

    return (
        <React.Fragment>
            <Backdrop className={classes.backdrop} open={openBackDrop} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ModalAntd 
                title="BUSQUEDA CLIENTE" 
                visible={isOpenSearch} 
                onCancel={handleCloseSearch} 
                okText=''
                cancelText='CERRAR'
                destroyOnClose
                okButtonProps={{ disabled: true,}}
                width={1000}
                bodyStyle={{maxHeight:500}}
                >
                    <Grid container spacing={0} justifyContent='center'>
                        <Grid item md={6} xs={11}>
                            <TextField 
                                id='SearchOptions'
                                fullWidth
                                label='Busqueda'
                                value={ getSearch || ''}
                                onChange={handleSearch}  
                                variant='outlined'
                                size='small'
                                margin='dense'
                            />
                        </Grid>
                        <Grid item>
                            <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                <span>
                                <IconButton 
                                    color='primary' 
                                    onClick={handleClickMenuBusqueda}  
                                    aria-controls="menu-column-busqueda" 
                                    aria-haspopup="true" 
                                    style={{position:'relative', top:12}}
                                    size='small'
                                >                            
                                    <MoreVertIcon />
                                </IconButton>
                                </span>
                            </Tooltip>
                            <Menu
                                id="menu-column-busqueda"
                                anchorEl={openMenuBusqueda}
                                keepMounted
                                open={Boolean(openMenuBusqueda)}
                                onClose={handleCloseMenuBusqueda}
                            >
                                {
                                    columnsSearch.map((el, index)=>
                                        <MenuItem 
                                            key={`${el.dataIndex}_${index}_`} 
                                            style={{width:'100%'}}
                                            onClick={()=>{
                                                setOptionSearch(el.dataIndex);
                                                setOpenMenuBusqueda(null)
                                            }}
                                        >
                                            {el.title}
                                        </MenuItem>
                                    )
                                }
                            </Menu>   
                        </Grid>
                        <Grid item xs={12}>
                            <TableAntd 
                                columns={columnsSearch} 
                                dataSource={ getSearch === '' ? allClientes.filter(el=> el.Status === 'Activo') : rows } 
                                pagination={{
                                    position: ['none', 'bottomLeft '],
                                }}
                                size='small'
                            />
                        </Grid>
                    </Grid>
            </ModalAntd>
            <Grid container style={{ padding: 5, height: '90vh', width: '99%', alignItems: 'start', alignContent: 'start' }} spacing={1}>
                <Scrollbars
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                >
                    <Grid item xs={12} className={classes.headerButton}>
                        <Paper style={{ width: '100%', padding: 10 }} elevation={3}>
                            <Grid container spacing={1} justifyContent='center' style={{ alignSelf: 'center' }}>
                                <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <SwapVerticalCircleIcon style={{ color: getReadyInfo ? 'green' : 'red' }} />
                                </Grid>
                                <Grid item style={{display:'grid', placeContent:'center'}}>
                                    <IconButton size='small' onClick={handleOpenSearch} color='primary'>
                                        <SearchIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <TooltipAntd title="Todos los Clientes?" color='BLUE' placement='left' >
                                        <CheckboxAntd
                                            checked={isAllClients}
                                            disabled={isSelectClient}
                                            onChange={({ target }) => { setAllClients(target.checked) }}
                                        />
                                    </TooltipAntd>
                                </Grid>
                                <Grid item xl={4} lg={4} md={9} sm={5} xs={8} >
                                    <Autocomplete
                                        id="Zona"
                                        options={dataZona.map(value => value.Zona)}
                                        value={zonaSelected || ''}
                                        fullWidth
                                        renderInput={(params) =>
                                            <TextField {...params}
                                                label="Zona"
                                                variant="outlined"
                                                size='small'
                                                fullWidth
                                                color='primary'
                                            />
                                        }
                                        onChange={(e, value, reason) => {
                                            if (reason === 'clear') {
                                                handleClearZona()
                                            } else {
                                                handleSelectedZona(value);
                                            }
                                        }}
                                    />
                                </Grid>
                                {
                                    widthWin === 'xs' || widthWin === 'sm' ?
                                        <Grid item xl={12} lg={12} md={12} sm={6} xs={12}>
                                            <Grid container justifyContent='space-around' spacing={2}>
                                                <Grid item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <TooltipAntd title="SYNC MIKROTIK" color='purple' >
                                                        <SwitchAntd checkedChildren="ON" unCheckedChildren="OFF" checked={getAddClientMikrotik} onChange={handleAddClientMikrotik} />
                                                    </TooltipAntd>
                                                </Grid>
                                                <Grid item>
                                                    {isSaving ? <FacebookCircularProgress size={35} /> :
                                                        <Tooltip title='GUARDAR' placement='left' arrow>
                                                            <span>
                                                                <Fab color='primary' size='small' onClick={handleAlertSaveCliente}>
                                                                    <SaveIcon />
                                                                </Fab>
                                                            </span>
                                                        </Tooltip>
                                                    }
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='RESET' placement='top' arrow>
                                                        <span>
                                                            <Fab color='primary' size='small' onClick={handleReset} disabled={elementDisable}>
                                                                <RefreshIcon />
                                                            </Fab>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='ADD SERVICE' placement='right' arrow>
                                                        <span>
                                                            <Fab color='primary' size='small' onClick={handleServicio} disabled={isNew}>
                                                                <AddCircleOutlineIcon />
                                                            </Fab>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        :
                                        <React.Fragment>
                                            <Grid item xl={1} lg={1} md={1} sm={6} xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <TooltipAntd title="SYNC MIKROTIK" color='purple' placement='right'>
                                                    <SwitchAntd checkedChildren="ON" unCheckedChildren="OFF" checked={getAddClientMikrotik} onChange={handleAddClientMikrotik} />
                                                </TooltipAntd>
                                            </Grid>
                                            <Grid item lg={2} md={4} sm={4} xs={12}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    style={{ color: '#fff' }}
                                                    size="large"
                                                    fullWidth
                                                    onClick={handleAlertSaveCliente}
                                                    startIcon={isSaving ? '' : <SaveIcon />}
                                                    disabled={elementDisable}
                                                >
                                                    {isSaving ? <FacebookCircularProgress size={20} /> : 'SAVE'}
                                                </Button>
                                            </Grid>
                                            <Grid item lg={2} md={4} sm={4} xs={12}>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    size="large"
                                                    fullWidth
                                                    onClick={handleReset}
                                                    startIcon={<RefreshIcon />}
                                                    disabled={elementDisable}
                                                >
                                                    RESET
                                                </Button>
                                            </Grid>
                                            <Grid item lg={2} md={4} sm={4} xs={12}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    style={{ color: '#fff' }}
                                                    size="large"
                                                    fullWidth
                                                    onClick={handleServicio}
                                                    startIcon={<AddCircleOutlineIcon />}
                                                    disabled={isNew}
                                                >
                                                    ADD
                                                </Button>
                                            </Grid>
                                        </React.Fragment>
                                }
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} style={{ height: 5 }}>
                        {isSavingClient && <LinearProgress color='secondary' />}
                        {isIpsCharging && <LinearProgress color='primary' />}
                    </Grid>
                    <Grid item xs={12} style={{ padding: 10 }}>
                        <Paper elevation={3} style={{ padding: 10, width: '100%' }}>
                            <Grid container spacing={3} >
                                {
                                    showAutocomplete ?
                                        <>
                                            <Grid item xl={4} lg={4} md={4} sm={4} xs={9} >
                                                <TextField
                                                    id='CI'
                                                    fullWidth
                                                    label='CI'
                                                    value={DatosF.CI || ''}
                                                    InputProps={{
                                                        startAdornment: <PermIdentityIcon color='primary' />,
                                                    }}
                                                    variant='outlined'
                                                    size='small'
                                                    disabled={!isSelectedZona}
                                                />
                                            </Grid>
                                            <Grid item xl={1} lg={1} md={2} sm={2} xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                                                <SwitchAntd checkedChildren="NOMBRES" unCheckedChildren="CEDULA" checked={showAutocomplete || false} onChange={handleShowAutocomplete} />
                                            </Grid>
                                            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}>
                                                <Autocomplete
                                                    id="Nombres"
                                                    options={
                                                        isSelectedZona
                                                            ? isAllClients
                                                                ? clientes.map(value => value.Nombres)
                                                                : clientes.filter(el => el.Status === 'Activo').map(value => value.Nombres)
                                                            : isAllClients
                                                                ? clientes.map(value => value.Nombres)
                                                                : clientes.filter(el => el.Status === 'Activo').map(value => value.Nombres)}
                                                    value={userName || ''}
                                                    disabled={!isSelectedZona}
                                                    renderInput={(params) => <TextField {...params} label="Nombres" variant="outlined" size='small' fullWidth />}
                                                    onChange={(e, value, reason) => {
                                                        console.log(reason)
                                                        if (reason === 'clear') {
                                                            handleResetName()
                                                        } else {
                                                            handleClientSelected(value);
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </>
                                        :
                                        <>
                                            <Grid item xl={4} lg={4} md={4} sm={4} xs={9} >
                                                <TextField
                                                    id='CI'
                                                    fullWidth
                                                    label='id'
                                                    value={DatosF.CI || ''}
                                                    onChange={handleDatosCI}
                                                    InputProps={{
                                                        startAdornment: <PermIdentityIcon color='primary' />,
                                                        endAdornment:
                                                            <IconButton aria-label="search" onClick={handleSearchCedula} disabled={!isSelectedZona} size='small'>
                                                                <SearchIcon color='primary' />
                                                            </IconButton>
                                                    }}
                                                    onKeyPress={(e) => {
                                                        const code = e.keyCode || e.which;
                                                        if (code === 13)
                                                            handleSearchCedula();
                                                    }}
                                                    variant='outlined'
                                                    size='small'
                                                    disabled={!isSelectedZona}
                                                />
                                            </Grid>
                                            <Grid item xl={1} lg={1} md={2} sm={2} xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                                                <SwitchAntd checkedChildren="NOMBRES" unCheckedChildren="CEDULA " checked={showAutocomplete || false} onChange={handleShowAutocomplete} />
                                            </Grid>
                                            <Grid item xl={7} lg={7} md={6} sm={6} xs={12} >
                                                <TextField
                                                    id='Nombres'
                                                    fullWidth
                                                    label='Nombres'
                                                    value={DatosF.Nombres || ''}
                                                    onChange={handleDatos}
                                                    InputProps={{
                                                        startAdornment: <AccountCircleIcon color='primary' />,
                                                    }}
                                                    variant='outlined'
                                                    size='small'
                                                    disabled={elementDisable}
                                                />
                                            </Grid>
                                        </>
                                }
                                {CorreosEl}
                                {CelularesEl}
                                {ConvencionalesEl}
                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1} justifyContent='center' style={{ padding: 10 }}>
                            {isSelectClient ? ServiciosEls : null}
                        </Grid>
                    </Grid>
                </Scrollbars>
            </Grid>

        </React.Fragment>
    );
};

const ElementCorreo = memo((props) => {

    const { index, total, disabledEl, handleCorreos, handleCrearCorreos, handleBorrarCorreos, data } = props;
    const [Datos, setDatos] = useState({ correo: '', id: data.id });
    let cantItem = index + 1;

    useEffect(() => { setDatos(data); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubBorrarCorreos = () => {
        handleBorrarCorreos(data.id);
    };

    const handleDatos = (e) => {
        setDatos({ ...Datos, correo: e.target.value });
    };

    const handleSubCorreos = () => {
        handleCorreos(data.id, Datos)
    };

    return (
        <Grid item xl={4} lg={4} md={6} sm={6} xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
            <TextField
                id={data.id}
                fullWidth
                label='Correo'
                type='email'
                onChange={handleDatos}
                value={Datos.correo || ''}
                onBlur={handleSubCorreos}
                InputProps={{
                    startAdornment: <AlternateEmailIcon color='primary' />
                }}
                variant='outlined'
                size='small'
                disabled={disabledEl}
            />
            {
                total === 1 ?
                    <IconButton onClick={handleCrearCorreos} disabled={disabledEl}>
                        <AddCircleOutlineIcon color='primary' />
                    </IconButton> :
                    <React.Fragment>
                        {
                            total === cantItem &&
                            <React.Fragment>
                                <IconButton onClick={handleCrearCorreos} >
                                    <AddCircleOutlineIcon color='primary' />
                                </IconButton>
                                <IconButton onClick={handleSubBorrarCorreos}>
                                    <DeleteIcon color='secondary' />
                                </IconButton>
                            </React.Fragment>
                        }
                    </React.Fragment>
            }

        </Grid>
    )


});

const ElementCelular = memo((props) => {

    const { index, total, disabledEl, handleBorrarCelulares, handleCelulares, handleCrearCelulares, data } = props;
    const [Datos, setDatos] = useState({ celular: data.celular, id: data.id });
    let cantItem = index + 1;

    useEffect(() => { setDatos(data); }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubBorrarCelulares = () => {
        handleBorrarCelulares(data.id);
    };

    const handleDatos = (e) => {
        setDatos({ ...Datos, celular: e.target.value.trim().split(" ").join("") });
    };

    const handleSubCelulares = () => {
        handleCelulares(data.id, Datos)
    };

    return (
        <Grid item xl={4} lg={4} md={6} sm={6} xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
            <TextField
                id={data.id}
                fullWidth
                label='Celular'
                onChange={handleDatos}
                onBlur={handleSubCelulares}
                value={Datos.celular || ''}
                InputProps={{
                    startAdornment: <PhoneIphoneIcon color='primary' />
                }}
                variant='outlined'
                size='small'
                type='tel'
            />
            {total === 1 ?
                <IconButton onClick={handleCrearCelulares} disabled={disabledEl}>
                    <AddCircleOutlineIcon color='primary' />
                </IconButton> :
                <React.Fragment>
                    {cantItem === total &&
                        <React.Fragment>
                            <IconButton onClick={handleCrearCelulares}>
                                <AddCircleOutlineIcon color='primary' />
                            </IconButton>
                            <IconButton onClick={handleSubBorrarCelulares}>
                                <DeleteIcon color='secondary' />
                            </IconButton>
                        </React.Fragment>
                    }
                </React.Fragment>
            }

        </Grid>
    )

});

const ElementConvencional = memo((props) => {
    const { index, total, disabledEl, handleBorrarConvencionales, handleConvencionales, handleCrearConvencionales, data } = props;
    const [Datos, setDatos] = useState({ convencional: '', id: data.id });
    let cantItem = index + 1;

    useEffect(() => {
        setDatos(data);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubBorrarConvencionales = () => {
        handleBorrarConvencionales(data.id);
    };

    const handleDatos = (e) => {
        setDatos({ ...Datos, convencional: e.target.value.trim().split(" ").join("") });
    };

    const handleSubConvencionales = () => {
        handleConvencionales(data.id, Datos)
    };

    return (
        <Grid item xl={4} lg={4} md={6} sm={6} xs={12} style={{ display: 'flex', flexDirection: 'row' }}>
            <TextField
                id={data.id}
                fullWidth
                label='Convencional'
                onChange={handleDatos}
                onBlur={handleSubConvencionales}
                value={Datos.convencional || ''}
                InputProps={{
                    startAdornment: <PhoneIcon color='primary' />
                }}
                variant='outlined'
                size='small'
                disabled={disabledEl}
                type='tel'
            />
            {total === 1 ?
                <IconButton onClick={handleCrearConvencionales} disabled={disabledEl}>
                    <AddCircleOutlineIcon color='primary' />
                </IconButton> :
                <React.Fragment>
                    {cantItem === total &&
                        <React.Fragment>
                            <IconButton onClick={handleCrearConvencionales}>
                                <AddCircleOutlineIcon color='primary' />
                            </IconButton>
                            <IconButton onClick={handleSubBorrarConvencionales}>
                                <DeleteIcon color='secondary' />
                            </IconButton>
                        </React.Fragment>
                    }
                </React.Fragment>
            }
        </Grid>
    );

});

function ClientAdd(props) {
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
            <YounetClientAdd widthWin={props.width} />
        </SnackbarProvider>
    );
};

export default withWidth()(ClientAdd);